<template>
  <div v-show="show" :class="['loader', { light: mode === 'light' }]" />
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseLoader',
  props: {
    show: { type: Boolean, default: false },
    mode: { type: String, default: 'dark' },
  },
});
</script>

<style lang="scss" scoped>
.loader {
  border: 2px solid transparent;
  border-radius: 50%;
  border-top: 2px solid #3498db;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
  margin: 0 7px 0 -20px;

  &.light {
    border: 2px solid $white;
    border-top: 2px solid $seer-stone;
  }
}
</style>
